import { gql } from "@apollo/client";

export const GET_ORG_USERS = gql`
  query getOrgUsers {
    organization_user {
      org_user_id
      org_id
      user_id
    }
  }
`;

export const GET_ORG_USERS_BY_ORG = gql`
  query getOrgUsersByOrg($orgId: uuid!) {
    organization_user(where: { org_id: { _eq: $orgId } }) {
      org_user_id
      org_id
      user_id
      user {
        user_id
        email
        role
        name
        picture_url
      }
    }
  }
`;
